import type { ReactNode } from 'react'
import clsx from 'clsx'
import styles from './Infrastructure.module.css'

interface OptionCardProps {
  /** Radio group name. */
  name: string
  value: string
  checked: boolean
  onChange: (value: string) => void
  title: string
  description?: ReactNode
}

/** A radio button presented as a card. It is a real radio input, so keyboard and screen-reader behaviour is native. */
export function OptionCard({ name, value, checked, onChange, title, description }: OptionCardProps) {
  return (
    <label className={clsx(styles.optionCard, checked && styles.optionCardSelected)}>
      <input type="radio" name={name} value={value} checked={checked} onChange={() => onChange(value)} />
      <span>
        <span className={styles.optionCardTitle}>{title}</span>
        {description && <span className={styles.optionCardText}>{description}</span>}
      </span>
    </label>
  )
}
